export default "__VITE_ASSET__hhJIx63P__"